interface ModeElo {
  currentElo: number;
}
export type CompetitiveMode = "competitive";

export type SubscriptionTier = "free" | "pro" | "betting";
export type SubscriptionStatus =
  | "active"
  | "past_due"
  | "cancelled"
  | "trialing"
  | "none";

export interface User {
  uid: string;
  username?: string;
  currentElo?: number;
  modes?: Record<CompetitiveMode, ModeElo>;
  // Subscription fields (written by Cloud Functions only)
  subscriptionTier?: SubscriptionTier;
  subscriptionStatus?: SubscriptionStatus;
  stripeCustomerId?: string;
  subscriptionId?: string;
  subscriptionEndDate?: string;
  // Ranked tracking (written by Cloud Functions only)
  rankedGamesPlayed?: number;
  // Usage tracking (written by Cloud Functions only)
  dailyApiCalls?: number;
  dailyApiCallsDate?: string;
  // Manual whitelist for the standalone /predictor page (set via Firebase console)
  predictorAccess?: boolean;
  // Manual whitelist for the /pro section (set via Firebase console)
  proAccess?: boolean;
}

export const FREE_DAILY_LIMIT = 5;

// Toggle to disable Pro gating (set to false to give everyone unlimited access)
export const PRO_FEATURES_ENABLED = false;

export function isProOrHigher(user: User | null): boolean {
  if (!PRO_FEATURES_ENABLED) return true;
  if (!user) return false;
  return (
    (user.subscriptionTier === "pro" || user.subscriptionTier === "betting") &&
    user.subscriptionStatus === "active"
  );
}
